module.exports = __webpack_public_path__ + "static/media/map_sample.35024142.jpg";